<template>
  <div style="margin-top: 46px">
    <div class="tips" v-show="type == 1">需要完成课程学习才能考试</div>

    <div class="content">
      <div class="chapterList">
        <div class="classTitle">
          {{ className }}
        </div>

        <div class="chapterBox" v-for="item in course" :key="item.COURSE_ID" @click="goPlayer(item)">
          <div class="imgsBox">
            <img :src="item.course.cimage" alt="" v-if="item.course.cimage != null && item.course.cimage != ''" />
            <img src="../../assets/new/xiaoBg.png" alt="" v-else />
          </div>
          <div class="t">
            <div class="t1" v-if="item.course">{{ item.course.cname }}</div>
            <div class="t2" v-if="item.course" v-show="type == 1">学时：{{ item.course.ccredithour }}学时</div>
            <div class="t2" v-if="item.course" v-show="type == 1">是否考试：{{ item.course.isExam == '01' ? '否' : '是' }}</div>
            <div class="t2" v-if="item.course" v-show="type == 1">
              学习状态：{{
                item.course.studyStatus == '01'
                  ? '未通过'
                  : item.course.studyStatus == '02'
                  ? '学习中'
                  : item.course.studyStatus == '03'
                  ? '已通过'
                  : '暂无状态'
              }}
            </div>
          </div>
          <div class="xxBtn">继续学习</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toMyClassCourse,ylxAddOrder } from '@/api/myClass';
import { Toast, Dialog, Loading } from 'vant';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      courseList: [],
      className: '',
      course: '',
      type:1,//2是职业培训课程
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goPlayer(item) {
         this.$router.push({
          path: '/chapterList',
          query: {
            courseId: item.course.id,
            name:item.course.cname,
            classId:this.$route.query.classId,
            type:this.$route.query.type,//区分是否职业培训
          }
        });
      // if (this.$route.query.type == 2) {
      //   this.$router.push({
      //     path: '/zyPlayer',
      //     query: {
      //       courseId: item.course.id,
      //       classId: item.classId,
      //       courseWareId: item.course.cwId,
      //       courseName: item.course.cname
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: '/player',
      //     query: {
      //       courseId: item.course.id,
      //       classId: item.classId,
      //       courseWareId: item.course.cwId,
      //       courseName: item.course.cname
      //     }
      //   });
      // }
    },
    toMyClassCourse(id) {
      let data = {
        classId: id,
        orderId: this.$route.query.orderId,
        pageNum: 1,
        pageSize: 100
      };
      ylxAddOrder({orderId: this.$route.query.orderId}).then(res => {
        console.log(res);
      })
      toMyClassCourse(data).then(res => {
        this.course = res.data.list.rows;
        console.log(this.course);
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.type = this.$route.query.type

    this.toMyClassCourse(this.$route.query.classId);
    this.className = this.$route.query.className;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.tips {
  width: 100%;
  height: 38px;
  background: rgba(250, 148, 89, 0.1);
  text-align: center;
  line-height: 38px;
  color: #fa9459;
  font-size: 13px;
}
.content {
  padding: 10px 15px;
  .chapterList {
    width: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 20px 15px 30px 15px;
    .classTitle {
      width: 100%;
      padding-bottom: 12px;
      border-bottom: 1px solid #eeeeee;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      font-weight: 600;
      font-size: 15px;
    }
    .chapterBox {
      margin-top: 16px;
      margin-bottom: 20px;
      display: flex;
      position: relative;
      .imgsBox {
        width: 110px;
        height: 88px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 8px 8px 8px 8px;
        }
      }
      .t {
        margin-left: 12px;
        .t1 {
          color: #000000;
          font-size: 15px;
          font-weight: 500;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 6px;
        }
        .t2 {
          color: #666666;
          font-size: 13px;
          margin-top: 4px;
        }
      }
      .xxBtn {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 74px;
        height: 32px;
        background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 13px;
      }
    }
  }
}
</style>
